import React from 'react';
import { Dropdown } from 'react-bootstrap';
import AdminListStatus from './AdminListStatus';
function AdminStatusDropdown({ statuses, selectedStatuses, handleStatusChange, setSelectedStatuses, type, label }) {
    // Conditionally filter the statuses based on type
    let filteredStatuses;
    if (type === 'requestor') {
        // filteredStatuses = statuses.filter(status => [2, 3, 0].includes(status.value));
        // filteredStatuses = statuses.filter(status => [0 , 1, 2].includes(status.value));
        filteredStatuses = statuses.filter(status => [0 , 1, 4, 9, 10].includes(status.value));
    } else if (type === 'admin') {
        // filteredStatuses = statuses.filter(status => [1, 5, 6, 7, 8, 9].includes(status.value));
        // filteredStatuses = statuses.filter(status => [1, 4, 5, 6, 7, 8].includes(status.value));

        filteredStatuses = statuses.filter(status => [1, 4, 5, 6, 7, 8, 9, 10].includes(status.value)).map(status => 
            // status.id === 1 ? { ...status, label: 'Open' } : status
            status.id === 1 ? { ...status, label: 'Scheduled' } : status
        );
    } else {
        filteredStatuses = statuses;  
    }

    return (
        <Dropdown className="d-inline-block">
            <Dropdown.Toggle className="p-0" id="statusFilterDropdown">
                {label}
            </Dropdown.Toggle>

            <Dropdown.Menu className="el-admin dropdwon-st"  renderOnMount={true} 
                popperConfig={{
                    strategy: "fixed",
                    placement: "bottom-start",
                    modifiers: [
                    {
                        name: "flip",
                        enabled: false
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: "clippingParents" //  Use nearest scrollable container
                        }
                    },
                    {
                        name: "computeStyles",
                        options: {
                            adaptive: false //  Prevent dynamic reposition glitch while scrolling
                        }
                    }
                ]
                }}>
                <form>
                    {filteredStatuses.map((status) => (
                        <AdminListStatus
                            selectedStatuses={selectedStatuses}
                            key={status.id}
                            status={status.value}
                            id={status.id}
                            onClick={handleStatusChange}
                            statuslabel={status.label}
                            type="sampleRequest"
                        />
                    ))}
                </form>
                <div>
                    <input
                        type="button"
                        value="Clear All"
                        className="btn btn-link"
                        onClick={() => setSelectedStatuses([])}
                    />
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default AdminStatusDropdown;
 